import { runtimeConfig } from './runtime-config';

export const environment = {
  production: false,
  graphqluri: runtimeConfig.graphqlUrl,
  apiUrl: runtimeConfig.restApiUrl,
  mercadoPagoPublicKey: window.MERCADOPAGO_PUBLIC_KEY,
  mercadoPagoCheckoutPublicKey: window.MERCADOPAGO_CHECKOUT_PUBLIC_KEY,
  sellerPlanId: '',
  paymentSuccessUrl: window.PAYMENT_SUCCESS_URL,
  googleOAuthClientId: window.GOOGLE_CLIENT_ID,
  googleOAuthRedirectUri: '',
  googleOAuthScope: window.GOOGLE_OAUTH_SCOPE,
  googleOAuthFields: '',
};
